import axiosInstance from "./axiosInstance";

export interface EmploymentStatusApi {
  publicId: string;
  statusName: string;
  displayOrder: number;
  color: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string | null;
}

export interface EmploymentStatusFilters {
  statusName?: string;
  isActive?: boolean;
  pageNo?: number;
  pageSize?: number;
}

export interface EmploymentStatusSearchPage {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  success: boolean;
  message: string;
  data: EmploymentStatusApi[];
  errors: unknown[];
}

export interface EmploymentStatusSearchResponse {
  success: boolean;
  message: string;
  data: EmploymentStatusSearchPage;
  errors: unknown[];
}

export interface CreateEmploymentStatusPayload {
  statusName: string;
  displayOrder: number;
  color: string;
  isActive: boolean;
}

export interface CreateEmploymentStatusResponse {
  success: boolean;
  message: string;
  data: string;
  errors: unknown[];
}

export interface UpdateEmploymentStatusResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: unknown[];
}

export interface DeleteEmploymentStatusResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: unknown[];
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getEmploymentStatuses = async (
  filters: EmploymentStatusFilters = {},
): Promise<EmploymentStatusSearchResponse> => {
  try {
    const response = await axiosInstance.get<EmploymentStatusSearchResponse>(
      "/hr/settings/employment-statuses/search",
      {
        params: {
          StatusName: filters.statusName || undefined,
          IsActive: filters.isActive ?? undefined,
          PageNumber: filters.pageNo ?? 1,
          PageSize: filters.pageSize ?? 20,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createEmploymentStatus = async (
  payload: CreateEmploymentStatusPayload,
): Promise<CreateEmploymentStatusResponse> => {
  try {
    const response =
      await axiosInstance.post<CreateEmploymentStatusResponse>(
        "/hr/settings/employment-statuses",
        payload,
        {
          headers: {
            ...getAuthHeader(),
          },
        },
      );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateEmploymentStatus = async (
  publicId: string,
  payload: CreateEmploymentStatusPayload,
): Promise<UpdateEmploymentStatusResponse> => {
  try {
    const response =
      await axiosInstance.put<UpdateEmploymentStatusResponse>(
        `/hr/settings/employment-statuses/${publicId}`,
        payload,
        {
          headers: {
            ...getAuthHeader(),
          },
        },
      );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteEmploymentStatus = async (
  publicId: string,
): Promise<DeleteEmploymentStatusResponse> => {
  try {
    const response =
      await axiosInstance.delete<DeleteEmploymentStatusResponse>(
        `/hr/settings/employment-statuses/${publicId}`,
        {
          headers: {
            ...getAuthHeader(),
          },
        },
      );

    return response.data;
  } catch (error) {
    throw error;
  }
};